import React, { Component } from "react";
import { Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import DishesListBox from "../DishesListBox";

import { webFont, textBlack, textGrey } from "../../config/theme";
import { getSavedDishes } from "../../redux/user";

const defaultChefImg = "/images/simple-chef.webp";

class FDishes extends Component {
  constructor (props) {
    super(props);
    this.mediaBoxRef = React.createRef();
    this.state = {
      featuredDishesList: []
    };
  }

  componentDidMount() {
    const { dispatch, userId } = this.props;
    dispatch(getSavedDishes(userId));
  }

  handleClick = dish => {
    const { history } = this.props;
    history.push("/home/dish-details", { dishId: dish.id, liked: true, saved: true, screen: 'saved' });
  };

  render() {
    const { savedDishes: featuredDishesList } = this.props;
    const clientWidth = this.mediaBoxRef ? this.mediaBoxRef.current ? this.mediaBoxRef.current.clientWidth : 510 : 510;

    let fChefs = null;
    if (featuredDishesList.length > 0) {
      fChefs = featuredDishesList.map(dish => {
        return (
          <DishesListBox
            dishImage={dish.media && dish.media.length ? dish.media[0].url : defaultChefImg}
            dishHeading={dish.name}
            dishDetail={dish.cuisines ? dish.cuisines.length > 3 ? 'Multi cuisine' : dish.cuisines.toString() : ""}
            dish={dish}
            dishChef={dish.chefName}
            handleClick={this.handleClick}
          />
          // <Grid
          //   item
          //   xs={12}
          //   sm={6}
          //   md={4}
          //   lg={4}
          //   key={dish.id}
          //   style={style.featuredItem}
          //   onClick={() => this.handleClick(dish)}
          // >
          //   <Grid container alignItems="flex-start" justify="flex-start">
          //     <Avatar
          //     data-test-id={"saveddishimg"}
          //       src={
          //         dish.media && dish.media.length
          //           ? dish.media[0].url
          //           : defaultChefImg
          //       }
          //       alt="Image not available"
          //       style={style.avatarImg}
          //     />
          //     <Grid  data-test-id={"saveddishname"}  item xs={12}>
          //       <Hidden only={["md", "sm"]}>
          //         <Typography
          //           align="left"
          //           variant="h6"
          //           style={style.chefName}
          //           gutterBottom={true}
          //         >
          //           {dish.name}
          //         </Typography>
          //       </Hidden>
          //       <Hidden only={["xs", "lg", "xl"]}>
          //         <Typography
          //           align="left"
          //           variant="h6"
          //           style={style.chefNameTab}
          //           gutterBottom={true}
          //         >
          //           {dish.name}
          //         </Typography>
          //       </Hidden>
          //     </Grid>
          //     <Grid data-test-id={"saveddishcuis"} item xs={12} style={{ flexDirection: 'row' }}>
          //       <Hidden only={["md", "sm"]}>
          //         <Typography
          //           align="left"
          //           variant="body1"
          //           style={style.chefCuisine}
          //           gutterBottom={true}
          //           noWrap={true}
          //         >
          //           {dish.cuisines ? dish.cuisines.length > 3 ? 'Multi cuisine' : dish.cuisines.toString() : ""}
          //         </Typography>
          //         <Typography
          //           align="left"
          //           variant="subtitle1"
          //           style={style.dishChefName}
          //           gutterBottom={true}
          //           noWrap={true}
          //         >
          //           {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
          //         </Typography>
          //       </Hidden>
          //       <Hidden only={["xs", "lg", "xl"]}>
          //         <Typography
          //           align="left"
          //           variant="body1"
          //           style={style.chefCuisineTab}
          //           gutterBottom={true}
          //           noWrap={true}
          //         >
          //           {dish.cuisines ? dish.cuisines.toString() : ""}
          //         </Typography>
          //         <Typography
          //           align="left"
          //           variant="subtitle1"
          //           style={style.dishChefName}
          //           gutterBottom={true}
          //           noWrap={true}
          //         >
          //           {dish.chefName ? `Offered by: ${dish.chefName}` : ''}
          //         </Typography>
          //       </Hidden>
          //     </Grid>
          //   </Grid>
          // </Grid>
        );
      });
    }

    return (
      <Grid container direction="row" style={style.ftGrid} ref={this.mediaBoxRef}>
        <Grid container alignItems="flex-start">
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }} />
          <Grid item xs={6} md={4} lg={4} xl={2} >
            <Typography variant="h5" style={{...style.ftText, textAlign: 'center' }} align={"center"}>
              Saved dishes
            </Typography>
          </Grid>
          <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 20 }}  />
        </Grid>
        <Grid className="dish-container" container alignItems={'center'}>
          <div className="dish-conatiner-row">
            {fChefs}
          </div>
        </Grid>

        {featuredDishesList.length === 0 && <Grid container alignItems={"center"} justify={"center"} style={{ marginTop: 40 }}>
          <Typography className="mb-40" variant="h5" style={style.ftText}>
            No saved dishes
          </Typography>
        </Grid>}
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    savedDishes: state.user.savedDishes,
    isChef: state.auth.isChef
  };
};

const FeaturedDishes = connect(mapStateToProps)(FDishes);

export default FeaturedDishes;

const style = {
  avatarImg: {
    maxWidth: 360,
    minWidth: 290,
    minHeight: 230,
    maxHeight: 250,
    borderRadius: 5,
    width: '100%',
  },
  avatarImgIPadLandscape: {
    maxWidth: 340,
    minWidth: 280,
    minHeight: 200,
    maxHeight: 250,
    borderRadius: 5,
    width: '98%',
  },
  ftGrid: {
    marginTop: 40,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    fontSize: 30,
    marginBottom: 10,
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    textAlign: 'left',
    margin: '12px 0 2px',
  },
  dishChefName: {
    fontFamily: webFont,
    color: textGrey,
    weight: 300,
    maxWidth: 300,
    fontSize: 12,
    marginTop: -5
  },
  chefNameTab: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
  },
  chefCuisine: {
    fontFamily: webFont,
    textAlign: 'left',
    fontSize: 15,
    color: '#979797',
    margin: 0,
  },
  chefCuisineTab: {
    fontFamily: webFont,
    color: textGrey,
    weight: 500,
    maxWidth: 400,
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  showBtn: {
    width: "220px",
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20,
    textTransform: "none",
    marginTop: 30,
    fontFamily: webFont
  }
};
